import { render, staticRenderFns } from "./ShowArticleCollectionPage.vue?vue&type=template&id=06f02014&"
import script from "./ShowArticleCollectionPage.vue?vue&type=script&lang=js&"
export * from "./ShowArticleCollectionPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports